window.storySoFar = "";
window.currentEvent = null;
window.currentChapter = null;
window.currentTextAnimation = null;
window.visitedEvents = [];
window.skippedEventsIds = [];
window.tagColors = [];
window.handleEventRequestId = 0;
window.isAutoPlaying = false;

window.topRowEvents = []; // "s" events
window.secondaryRowEvents = []; // "p" events
window.generalEvents = []; // "g" events (suppressed for now)
window.isSelectingEvent = false;

window.allPerspectives = {
  "bertko": { 
    name: "bertko", 
    text: "Môj pohľad na vec.", 
    checked: true, 
    disabled: true, 
    weight: 50,
    availableInCurrentEvent: true
  }
};

function appendSessionEventLog(eventLogItem) {
  try {
    const raw = sessionStorage.getItem("sessionEventLog");
    const currentLog = raw ? JSON.parse(raw) : [];
    currentLog.push(eventLogItem);
    sessionStorage.setItem("sessionEventLog", JSON.stringify(currentLog));
  } catch (err) {
    console.warn("Failed to append session event log:", err);
  }
}

/**
 * Update the Header with current and next chapter
 */
function updateHeader() {
  const leftSlot = document.getElementById("header-left");
  const rightSlot = document.getElementById("header-right");
  
  if (currentChapter) {
    leftSlot.textContent = `${parseInt(sessionStorage.getItem('currentChapterId'), 10)+1}. ${currentChapter.title}`;
  }

  rightSlot.innerHTML = "";
  // Next chapter must always be derived from current chapter definition.
  if (currentChapter && Array.isArray(currentChapter.next)) {
    const nextCh = currentChapter.next.find(e => e.type === "ch");
    if (nextCh) {
      const btn = document.createElement("button");
      btn.textContent = `${parseInt(sessionStorage.getItem('currentChapterId'), 10)+2}. ${nextCh.title} \u2192`;
      btn.addEventListener("click", () => {
        const currentChapterId = parseInt(sessionStorage.getItem('currentChapterId'), 10);
        sessionStorage.setItem('currentChapterId', currentChapterId+1);
        window.location.href = "app.html";
      });
      rightSlot.appendChild(btn);
    } else {
      // Artificial last chapter button for transition to End Video screen
      const btnEnd = document.createElement("button");
      btnEnd.textContent = "Koniec \u2192";
      btnEnd.addEventListener("click", () => {
        window.location.href = "outro.html";
      });
      rightSlot.appendChild(btnEnd);
    }
  }
}

/**
 * Helper to show/hide the perspective pitch
 */
function setPerspectiveVisibility(visible) {
  const container = document.getElementById("pitch-app");
  const canvas = document.getElementById("canvas-container");
  const label = document.getElementById("interactive-label");

  if (visible) {
    container.style.display = 'block';
    canvas.style.display = 'none';
    label.textContent = isAutoPlaying == true ? getLabel("HRA") : getLabel("VÝBER ZOSTAVY");
  } else {
    container.style.display = 'none';
    canvas.style.display = 'block';
    label.textContent = isSelectingEvent ? getLabel("VÝBER FÁZY TRÉNINGU") : getLabel("DRIL");
  }

  const app = document.getElementById('pitch-app');
  if (app) {
    if (isAutoPlaying) {
      app.style.pointerEvents = 'none';
      app.style.userSelect = 'none';
      app.style.touchAction = 'none';
    } else {
        app.style.pointerEvents = 'auto';
        app.style.userSelect = 'auto';
        app.style.touchAction = 'auto';
    }
  }
}

async function newChapter(event) {
  currentChapter = event;
  storySoFar = "";
  topRowEvents = event.next || [];
  secondaryRowEvents = [];
  
  updateHeader();
  setPerspectiveVisibility(false);
}

window.onCanvasEventHit = (event) => {
  handleNewEvent(event);
};

async function handleNewEvent(event) {
  const requestId = ++handleEventRequestId;

  // Hide interactive elements during transition
  isSelectingEvent = false;
  if (typeof window.setCanvasEventsVisibility === 'function') {
    window.setCanvasEventsVisibility(false);
  }

  let fullEvent;
  try {
    let eventId = typeof event === 'string' ? event : event.id;
    const res = await fetch(`/api/event/${eventId}`);
    if (!res.ok) throw new Error(`Could not fetch event ${eventId}`);
    fullEvent = await res.json();
    localizeEvent(fullEvent);
    
    // Resolve next events from IDs to full objects
    if (fullEvent.next && fullEvent.next.length > 0) {
      const resolvedNext = [];
      for (let nextItem of fullEvent.next) {
        let nextId = typeof nextItem === 'string' ? nextItem : nextItem.id;
        try {
          const nextRes = await fetch(`/api/event/${nextId}`);
          if (nextRes.ok) {
            const nextObj = await nextRes.json();
            localizeEvent(nextObj);
            resolvedNext.push(nextObj);
          }
        } catch(e) {}
      }
      fullEvent.next = resolvedNext;
    }
  } catch (err) {
    fullEvent = event;
  }

  // Drop stale async result if a newer event request already started.
  if (requestId !== handleEventRequestId) return;

  currentEvent = fullEvent;
  visitedEvents.push(currentEvent.id);

  if (currentEvent.type === "ch") {
    newChapter(currentEvent);
    completeEventProcessing([], { useAI: false }); 
  } else {
    updatePerspectivesForCurrentEvent();
  }
}

function updatePerspectivesForCurrentEvent() {
  Object.keys(allPerspectives).forEach(name => {
    allPerspectives[name].availableInCurrentEvent = (name === "bertko");
  });

  if (currentEvent && currentEvent.perspectives) {
    currentEvent.perspectives.forEach(pObj => {
      const name = Object.keys(pObj)[0];
      const text = pObj[name];
      if (!allPerspectives[name]) {
        allPerspectives[name] = { name, text, availableInCurrentEvent: true };
      } else {
        allPerspectives[name].availableInCurrentEvent = true;
        allPerspectives[name].text = text;
      }
    });
  }

  let availableNames = Object.values(allPerspectives)
    .filter(p => p.availableInCurrentEvent)
    .map(p => p.name);

  availableNames.sort((a, b) => {
    if (a === "bertko") return -1;
    if (b === "bertko") return 1;
    return 0;
  });

  if (availableNames.length > 0) {
    setPerspectiveVisibility(true);
    if (typeof PitchEngine !== 'undefined') {
        PitchEngine.init(availableNames, "#pitch-app", onWhistleBlown, 1.0);
    }
  } else {
    setPerspectiveVisibility(false);
    completeEventProcessing([]);
  }
}

/**
 * Called by PitchEngine when the whistle is clicked
 */
async function onWhistleBlown() {
    const engineResults = PitchEngine.getResults();
    console.log(
      "Pitch raw percentages:",
      engineResults.map((res) => ({ name: res.name, rawPercentage: res.percentage }))
    );
    const chosenPerspectives = engineResults
      .filter(res => res.percentage > 0)
      .map(res => ({
        name: res.name,
        text: allPerspectives[res.name].text,
        val: res.percentage
      }));

    // no player was chosen
    if (chosenPerspectives.length === 0) {
        alert("Prosím, vyberte aspoň jedného hráča!");
        return;
    }
    
    // only bertko was chosen
    if (chosenPerspectives.length === 1 && chosenPerspectives[0].name === "bertko") {
        isAutoPlaying = false;
        setPerspectiveVisibility(false);
    } else {
        isAutoPlaying = true;
        // Keep pitch visible until animation completes
    }

    await completeEventProcessing(chosenPerspectives);

    if (isAutoPlaying && currentTextAnimation) {
        currentTextAnimation.play();
    }
}

function initRevealAnimation(textElement) {
  const split = new SplitType(textElement, { types: 'lines,words' });
  const wrapper = document.getElementById("texts-content-wrapper");
  const tl = gsap.timeline({ paused: true });

  // 1. Initial setup: hide words
  gsap.set(split.words, { opacity: 0 });

  // 2. Hide the new text below the fold.
  // Since it's flex-end, the new text is at the bottom of the container.
  // We shift the wrapper DOWN by the total height of the new text element.
  const newTextHeight = textElement.offsetHeight;
  gsap.set(wrapper, { y: `+=${newTextHeight}` });

  split.lines.forEach((line) => {
    const wordsInLine = line.querySelectorAll('.word');
    const lineHeight = line.offsetHeight;
    
    // Move the whole content wrapper up by one line height
    // This brings the next line into view from the bottom border
    tl.to(wrapper, {
      y: `-=${lineHeight}`,
      duration: 0.6,
      ease: "power2.out"
    });

    // Reveal words in this line
    tl.to(wordsInLine, {
      opacity: 1,
      stagger: 0.08,
      duration: 0.25
    }, "-=0.4"); // Overlap with the shift
  });
  
  tl.eventCallback("onComplete", () => {
      // Animation finishes -> Show next chapter button in header
      updateHeader();

      let hasMedia = false;
      if (currentEvent && currentEvent.media && currentEvent.media.length > 0) {
          const validImageExts = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];
          const validVideoExts = ['mp4', 'webm', 'ogg'];
          const mediaHtml = currentEvent.media.map(m => {
             const path = "media/" + m.path;
             const ext = path.split('.').pop().toLowerCase();
             if (validImageExts.includes(ext)) {
                 return `<a href="${path}" data-pswp-width="1200" data-pswp-height="800" target="_blank" style="aspect-ratio: 1; display: block; border: 1px solid var(--accent-color);">
                           <img src="${path}" alt="image" style="width: 100%; height: 100%; object-fit: cover; display: block;" />
                         </a>`;
             } else if (validVideoExts.includes(ext)) {
                 // Video item for PhotoSwipe
                 return `<a href="${path}" data-pswp-type="video" data-pswp-width="1920" data-pswp-height="1080" target="_blank" style="aspect-ratio: 1; display: flex; align-items: center; justify-content: center; border: 1px solid var(--accent-color); background: #000; position: relative;">
                           <video src="${path}" style="width: 100%; height: 100%; object-fit: cover;"></video>
                           <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background: rgba(0,0,0,0.5); padding: 5px 10px; border-radius: 4px; pointer-events: none; font-size: 12px; font-weight: bold;">VIDEO</div>
                         </a>`;
             }
             return '';
          }).filter(Boolean).join('');
          
          if (mediaHtml) {
              hasMedia = true;
              const galleryContainer = document.getElementById("gallery-container");
              galleryContainer.innerHTML = mediaHtml;
              galleryContainer.style.display = 'grid';
              
              const images = galleryContainer.querySelectorAll('img');
              images.forEach(img => {
                  const updateSize = () => {
                      if (img.naturalWidth && img.naturalHeight) {
                          img.parentElement.setAttribute('data-pswp-width', img.naturalWidth);
                          img.parentElement.setAttribute('data-pswp-height', img.naturalHeight);
                      }
                  };
                  if (img.complete) {
                      updateSize();
                  } else {
                      img.onload = updateSize;
                  }
              });
              
              const contBtn = document.getElementById("gallery-continue-btn");
              contBtn.style.display = 'block';
              
              setPerspectiveVisibility(false);
              const interactiveLabel = document.getElementById("interactive-label");
              interactiveLabel.textContent = getLabel("PRESTÁVKA");
              
              if (window.pswpLightboxInstance) {
                  window.pswpLightboxInstance.destroy();
              }
              window.pswpLightboxInstance = new window.PhotoSwipeLightbox({
                gallery: '#gallery-container',
                children: 'a',
                pswpModule: () => import(/* webpackIgnore: true */ 'https://unpkg.com/photoswipe@5.4.2/dist/photoswipe.esm.js')
              });
              
              if (window.PhotoSwipeVideoPlugin) {
                  new window.PhotoSwipeVideoPlugin(window.pswpLightboxInstance, {});
              }
              
              window.pswpLightboxInstance.init();
              
              contBtn.onclick = () => {
                  galleryContainer.style.display = 'none';
                  contBtn.style.display = 'none';
                  
                  isSelectingEvent = true;
                  setPerspectiveVisibility(false);
                  
                  if (typeof window.setCanvasEventsVisibility === 'function') {
                    window.setCanvasEventsVisibility(true);
                  }
                  refreshCanvasEvents();
              };
          }
      }
      
      if (!hasMedia) {
          isSelectingEvent = true;
          setPerspectiveVisibility(false);
          if (typeof window.setCanvasEventsVisibility === 'function') {
            window.setCanvasEventsVisibility(true);
          }
          refreshCanvasEvents();
      }
      isAutoPlaying = false;
  });
  
  currentTextAnimation = tl;
}

window.setTextAnimationState = (shouldPlay) => {
  if (!currentTextAnimation) return;
  if (isAutoPlaying) return; // Prevent manual interaction from overriding auto-play
  if (shouldPlay) currentTextAnimation.play();
  else currentTextAnimation.pause();
};

async function completeEventProcessing(chosenPerspectives = [], options = {}) {
  const { useAI = true } = options;
  const eventInProgress = currentEvent;
  if (!eventInProgress) return;

  let newEventText = eventInProgress.text;
  
  if (useAI) {
    const generatedNewEventRes = await generateStoryTextForCurrentEvent(eventInProgress, chosenPerspectives);
    if (generatedNewEventRes) {
      newEventText = generatedNewEventRes.text;
    }
  }

  const normalizedNewEventText = (newEventText || "").trim();
  if (normalizedNewEventText) {
    storySoFar = storySoFar
      ? `${storySoFar}\n\n${normalizedNewEventText}`
      : normalizedNewEventText;
  }

  if (eventInProgress.next) {
    eventInProgress.next.forEach(nextEv => {
        if (nextEv.type === "p") {
          if (!secondaryRowEvents.find(e => e.id === nextEv.id)) {
            secondaryRowEvents.push(nextEv);
          }
        } else if (nextEv.type === "s") {
          if (!topRowEvents.find(e => e.id === nextEv.id)) {
            topRowEvents.push(nextEv);
          }
        }
      });
  }

  const contentWrapper = document.getElementById("texts-content-wrapper");
  const eventDiv = document.createElement("div");
  eventDiv.className = "story-event";
  eventDiv.textContent = newEventText;
  contentWrapper.appendChild(eventDiv);

  initRevealAnimation(eventDiv);

  appendSessionEventLog({
    eventId: eventInProgress?.id || "",
    eventTitle: eventInProgress?.title || "",
    originalText: eventInProgress?.text || "",
    aiText: newEventText || "",
    timestamp: new Date().toISOString()
  });
}

function refreshCanvasEvents() {
  const sEvents = topRowEvents.filter(e => e.type === "s" && !visitedEvents.includes(e.id));
  const pEvents = secondaryRowEvents.filter(e => !visitedEvents.includes(e.id));
  
  // Only S and P events on canvas
  const combined = [...sEvents, ...pEvents];
  
  if (typeof window.updateCanvasEvents === 'function') {
    window.updateCanvasEvents(combined);
  }
}

async function generateStoryTextForCurrentEvent(eventToGenerate, chosenPerspectives = []) {  
  if (!eventToGenerate) return;
  try {
    const eventPayload = {
      title: eventToGenerate.title,
      text: eventToGenerate.text
    };

    const userLanguage = sessionStorage.getItem("userLanguage") || "slovak";

    const response = await fetch("/api/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event: eventPayload,
        skippedEventsIds: skippedEventsIds,
        storySoFar: storySoFar,
        chosenPerspectives: chosenPerspectives,
        userLanguage: userLanguage
      })
    });

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(`/api/chat failed (${response.status}): ${errorBody}`);
    }

    return await response.json();
  } catch (err) {
    console.error("Error generating story text:", err);
    return null;
  }
}

async function fetchJsonOrNull(url) {
  try {
    const res = await fetch(url);
    if (!res.ok) {
      console.warn(`Fetch failed for ${url}: ${res.status}`);
      return null;
    }
    return await res.json();
  } catch (err) {
    console.warn(`Fetch error for ${url}:`, err);
    return null;
  }
}

let appBootstrapped = false;

async function main() {
  // Non-critical preload: do not block startup on models/colors failures.
  fetchJsonOrNull("/api/models").then((models) => {
    if (models) console.log(models);
  });
  fetchJsonOrNull("/api/colors").then((colors) => {
    if (colors) console.log(colors);
  });

  const chapterIds = await fetchJsonOrNull("/api/chapterIds");

  if (!Array.isArray(chapterIds) || chapterIds.length === 0) {
    console.error("No chapter IDs available.");
    return;
  }
  console.log(chapterIds);

  const rawChapterIndex = Number.parseInt(sessionStorage.getItem("currentChapterId"), 10);
  const chapterIndex = Number.isInteger(rawChapterIndex) && rawChapterIndex >= 0
    ? Math.min(rawChapterIndex, chapterIds.length - 1)
    : 0;
  sessionStorage.setItem("currentChapterId", String(chapterIndex));

  const currentChapterId = chapterIds[chapterIndex];
  const chapterEvent = await fetchJsonOrNull(`/api/event/${currentChapterId}`);
  if (!chapterEvent) {
    console.error(`Failed to load chapter event "${currentChapterId}".`);
    return;
  }
  localizeEvent(chapterEvent);

  isSelectingEvent = true;
  setPerspectiveVisibility(false);
  await handleNewEvent(chapterEvent);
}

function bootstrapApp() {
  if (appBootstrapped) return;
  appBootstrapped = true;
  main().catch((err) => {
    console.error("App bootstrap failed:", err);
    appBootstrapped = false;
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrapApp, { once: true });
} else {
  bootstrapApp();
}

window.addEventListener("pageshow", bootstrapApp);
